import { useState } from 'react';
import Modal from './modal';
import Input from '../input/Input';
import Card from '../card/Card';

interface RateTypesModalProps {
  isOpen: boolean;
  onClose: () => void;
  rateType: {
    id: number;
    name: string;
    baseValue: number;
  } | null;
  onSave: (id: number, baseValue: number) => void;
  loading?: boolean;
}

const RateTypesModal: React.FC<RateTypesModalProps> = ({
  isOpen,
  onClose,
  rateType,
  onSave,
  loading = false,
}) => {
  const [baseValue, setBaseValue] = useState<string>('');

  const handleSave = () => {
    if (rateType && baseValue.trim() !== '') {
      const numericValue = parseFloat(baseValue);
      if (!isNaN(numericValue)) {
        onSave(rateType.id, numericValue);
      }
    }
  };

  const handleClose = () => {
    setBaseValue('');
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title={`Editar tipo de tasa: ${rateType?.name || ''}`}
      primaryText='Guardar'
      primaryVariant='primary'
      secondaryText='Cancelar'
      secondaryVariant='secondary'
      onSecondaryAction={handleClose}
      onPrimaryAction={handleSave}
      loadingPrimaryBtn={loading}
      primaryActionDisabled={!baseValue.trim() || loading}
    >
      <Card margin={{ top: '3' }}>
        <Input
          label='Valor base'
          type='number'
          value={baseValue}
          onChange={(e) => setBaseValue(e.target.value)}
          placeholder={rateType?.baseValue?.toString() || '0'}
        />
      </Card>
    </Modal>
  );
};

export default RateTypesModal;
